/**
 * Cache keys for the new `useFetchData` hook.
 * Keeping keys in one place so that we can invalidate them anywhere without having to know the exact key.
 */

export const UseFetchCacheKeys = {
  AutonomousMonitor: 'AutonomousMonitor',
  AutonomousMonitorList: 'AutonomousMonitorList',
  AutonomousMonitorSupportOutreach: 'AutonomousMonitorSupportOutreach',
  UserMonitorList: 'UserMonitorList',
  Emails: 'Emails',
  EmailLanguages: 'EmailLanguages',
} as const;
